import script from "./Reclamos.vue?vue&type=script&setup=true&lang=js"
export * from "./Reclamos.vue?vue&type=script&setup=true&lang=js"

import "./Reclamos.vue?vue&type=style&index=0&id=43b75a6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b75a6a"]])

export default __exports__